/* RESPONSIBLE TEAM: team-knowledge-foundations */
import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type KnowledgeHubService from 'embercom/services/knowledge-hub-service';
import { action } from '@ember/object';
import type AiAgentSetupService from 'embercom/services/ai-agent-setup-service';
import type KnowledgeHubDrawerEditorService from 'embercom/services/knowledge-hub-drawer-editor-service';
import type KnowledgeOverviewController from 'embercom/controllers/apps/app/knowledge-hub/overview';
import type IntlService from 'embercom/services/intl';
import type CopilotApi from 'embercom/services/copilot-api';

export default class KnowledgeHubOverviewIndexRoute extends Route {
  @service declare appService: AppService;
  @service declare knowledgeHubService: KnowledgeHubService;
  @service declare intercomEventService: $TSFixMe;
  @service declare aiAgentSetupService: AiAgentSetupService;
  @service declare knowledgeHubDrawerEditorService: KnowledgeHubDrawerEditorService;
  @service declare contentImportService: any;
  @service declare intl: IntlService;
  @service declare copilotApi: CopilotApi;

  get app() {
    return this.appService.app;
  }

  async model() {
    // For discovery banner (fin live status badge)
    this.aiAgentSetupService.loadFinWorkflowsCount();
    this.aiAgentSetupService.loadSetupRulesets();

    this.copilotApi.refreshCopilotSettingsData(); // For conversation excerpt content source and conversation and macros sections
    this.copilotApi.setup(); // For the preview composer

    this.contentImportService.fetchContentReviewSummary();

    // For overview page, custom answer counts shouldn't block rendering because it's down on the page
    this.aiAgentSetupService.loadCustomAnswerCounts();

    // Clear existing API so UnifiedContent creates a fresh one with proper search
    if (this.appService.app.canUseUnifiedContentUI) {
      this.knowledgeHubService.resetApiForUnifiedContent();
    }

    // Whereas other numbers are shown first time the overview page is rendered
    return this.aiAgentSetupService.loadKnowledgeUsageSummary();
  }

  @action
  didTransition() {
    this.intercomEventService.trackEvent('knowledge-hub-sources-page-visited');
  }

  resetController(controller: KnowledgeOverviewController, isExiting: boolean) {
    if (isExiting) {
      this.knowledgeHubDrawerEditorService.removeEmberStickyQueryParams(controller);
      controller.set('openSalesforceSync', undefined);
      controller.set('salesforceSyncStep', undefined);
      controller.set('errorCode', undefined);
      controller.set('salesforceSyncSourceId', undefined);
      controller.set('openConversationIngestionDrawer', undefined);
    }
  }

  get titleToken() {
    return this.app.canUseStandalone ? this.intl.t('standalone.navbar.content') : undefined;
  }
}
